module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_henna-simpanen_A4.85bb379.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_henna-simpanen_A4.pdf
// module id = qfbM
// module chunks = 22